export const USER_VALIDATION_ERROR = "USER_VALIDATION_ERROR"
export const USER_VALIDATION = "USER_VALIDATION"
export const USER_VALIDATION_SUCCESS = "USER_VALIDATION_SUCCESS"

